import axios from 'axios'
import { Toast } from 'vant'
const BASE_URL = process.env.NODE_ENV === 'development' ? '/again' : 'https://xf.xzhouse.com.cn/api/'
const service = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    timeout: 60000
})

let loadingInstance = null
let num = 0

service.interceptors.request.use(
    config => {
        var ua = navigator.userAgent;
        var uaList = ua.split(" ");
        var token = "";
        for (var i = 0; i < uaList.length; i++) {
            if (uaList[i].indexOf("token") > -1) {
                token = uaList[i].split("=")[1];
                break;
            }
        }
        if (token != "") {
            config.headers['OLT'] = token;
        }
        if (num == 0) {
            console.log("开始")
            loadingInstance = Toast.loading({
                forbidClick: true,
                message: '加载中...',
                duration: 0,
            })
        }
        num++
        return config
    },
    error => {
        num--
        Toast.fail('连接失败')
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        num--
        if (num == 0 && loadingInstance) {
            loadingInstance.clear()
        }
        if (response.status === 200) {
            const data = response.data
            return data
        }
    },
    error => {
        loadingInstance.close()
        Toast.fail('请求超时')
        return Promise.reject(error)
    }
)

export default service